<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal notifyModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true"
  [style]="{'max-width':'780px','width':'100%', 'top': '70px' ,'height':'630px'}" [resizable]="false">

  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between mx-2">
      <h6 class="notify-title">Follow</h6>
      <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text">
        <img src="assets/qwyn/icons/close.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="notify-body mx-2">
      <div class="notify-holder" style="padding: 12px; margin: 8px 0px 0px !important; top: 8px;">
        <div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" (change)="addLoginUser($event)" [checked]="notifyMe" class="custom-control-input" id="notifyCheckbox" name="notifyCheck">
            <label class="custom-control-label follow-control-label" for="notifyCheckbox">Also notify me when inquiry changes</label>
          </div>
        </div>
        <div class="d-flex flex-row py-3" style="justify-content:start;">
          <div class="d-flex flex-column assign-width" style="margin-right: 60px">
           
            <div class="d-flex flex-column flex-nowrap advance-search-elem">
              <div class="Owner-checkbox mobileView-ownership nominate-ownership ownership-listbox-grp">
                <span class="follow-box-label">Assigned group</span>
                <app-checkbox-list #groupname [placeholder]="'Quick Search...'" [name]="'value'" [items]="groups"  [listStyle]="{'height':'178px'}"
                styleClass="notifyClass" checked="groupNames.binary" (onItemChecked)="getSelectedGroup($event)"></app-checkbox-list>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column owner-width">
            <div class="Owner-checkbox nominate-ownership mobileView-ownership ownership-listbox-grp">
              <span class="follow-box-label">Owner</span>
              <app-checkbox-list #owner [searchIcon]="true" [placeholder]="'Quick Search...'" [name]="'ownership'" [items]="assignedUsersList"
              [listStyle]="{'height':'178px'}"  styleClass="notifyClass" (onItemChecked)="getSelectedItems($event)"></app-checkbox-list>
            </div>
          </div>
        </div>
        <div *ngIf="isOwnerSelected" style="font-size:14px; margin-left: 27.2em; font-family:OpenSans; font-weight: normal; color:#ff0000">Please select atleast one owner.</div>
        <div class="follow-control-label">Reason for notification:*</div>
        <div *ngIf="isReason" style="font-size:14px; font-family:OpenSans; font-weight: normal; color:#ff0000">Reason for Notification is mandatory.</div>
        <div class="d-flex flex-row align-items-center mb-4">
          <div class="label-text" for="reason"></div>
          <div class="d-flex flex-row align-items-center dd-comp">
            <div class="d-flex flex-row w-100 align-items-center">
              <textarea rows="4" cols="50" name="reason" [value]="reason" [(ngModel)]="reason" style="width: 100%"></textarea>
            </div>
          </div>
        </div>

      </div>
  </div>
  
    <div class="d-flex flex-row flex-wrap justify-content-center px-3 btn-wrappersn">
      <button type="submit" class="btn search-btn me-4 mobile-btn" (click)="setNotification()">Apply</button>
      <button type="reset" class="btn clear-btn mobile-btn" (click)="resetFields()">Reset</button>
    </div>
  
</p-dialog>
